import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import {
  TransactionListBillingNum,
  TransactionListOrderByNum,
  TransactionListTypeNum,
  TransactionsListReportFormModel,
} from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): TransactionsListReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  system_posting: false,
  cash_register_ids: null,
  cashier_ids: null,
  operation_id: null,
  charge_group_ids: null,
  billing_group_ids: null,
  charge_code_ids: null,
  type: TransactionListTypeNum.ALL,
  billing: TransactionListBillingNum.All,
  order_by: TransactionListOrderByNum.DATE,
  file_type: 'pdf',
});
